// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__yuYhL","label":"styles_label__nC4CD","select":"styles_select__m3MfG","error":"styles_error__72mlj","labelGap":"styles_labelGap__LiDf7"};